<template>
  <div class="report p-3">
    <joint-report-cover-page :noOfPages="noOfPages" :reportRows="reportRows"></joint-report-cover-page>
    <joint-report-page v-for="n in noOfPages" :key="n" :pageNo="n" :noOfPages="noOfPages" :reportRows="pageSlice(reportRows, n)"></joint-report-page>
  </div>
</template>

<script>

import { Carousel, Slide } from 'vue-carousel'

export default {
  props: ['reportRows', 'enableModal'],
  components: {
    Carousel,
    Slide
  },
  data: function () {
    return {
      reportRowsPerPage: 1
    }
  },
  computed: {
    noOfPages: function () {
      return Math.ceil(this.reportRows.length / this.reportRowsPerPage)
    }
  },
  methods: {
    pageSlice: function (val, n) {
      if (n === 1) {
        return val.slice(0, this.reportRowsPerPage)
      } else {
        return val.slice((n - 1) * this.reportRowsPerPage, (n * this.reportRowsPerPage))
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// JointReport.vue?43637bb6